/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReviver } from '../../factoriesAny.js';
export var reviverDependencies = {
  createReviver
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesReviver.generated.js
// module id = null
// module chunks = 